module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-login"
  }, [_c('app-navigation'), _vm._v(" "), _c('main', {
    staticClass: "o-login__main"
  }, [_c('div', {
    staticClass: "o-login__main__logo c-login-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.platformImages.login_logo,
      "srcset": _vm.platformImages.login_logo + ', ' +
        _vm.platformImages.login_logo_2x + ' 2x',
      "alt": _vm.$t('web.login.alt_text_login_logo')
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "c-card c-card--login js-login-card"
  }, [_c('form', [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.login.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [(_vm.error_message) ? _c('div', {
    staticClass: "c-validation t-toast-danger is-not-valid"
  }, [_vm._v("\n              " + _vm._s(_vm.error_message) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "c-card__subtitle-h3",
    attrs: {
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.login.email_label')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.username),
      expression: "request.username"
    }],
    class: {
      'is-not-valid': _vm.errors.username
    },
    attrs: {
      "id": "username",
      "type": "email",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.username) ? _c('div', {
    staticClass: "c-validation t-alert-danger is-not-valid",
    attrs: {
      "id": "username-error",
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.errors.username[0]))]) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "c-card__subtitle-h3",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.login.password_label')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.password),
      expression: "request.password"
    }],
    class: {
      'is-not-valid': _vm.errors.password
    },
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.password) ? _c('div', {
    staticClass: "c-validation t-alert-danger is-not-valid",
    attrs: {
      "id": "password-error",
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.errors.password[0]))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer c-card--login__footer"
  }, [_c('button', {
    staticClass: "c-button c-button--full-width t-button-primary js-submit-login",
    attrs: {
      "disabled": _vm.loggingIn
    },
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.login.submit_button')) + "\n          ")]), _vm._v(" "), (_vm.websiteConfig.enrollment_enabled) ? _c('router-link', {
    staticClass: "c-card__footer__text-link u-float-left t-link",
    attrs: {
      "to": {
        name: 'Signup'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.login.signup_link_text')))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "c-card__footer__text-link u-float-right t-link",
    attrs: {
      "to": {
        name: 'ForgotPassword'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.login.forgot_password_link_text')))])], 1)])])]), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('div', {
    staticClass: "c-login-hero-image"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": _vm.platformImages.login_background_desktop + ', ' +
        _vm.platformImages.login_background_desktop_2x + ' 2x',
      "media": "(min-width: 960px)"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": _vm.platformImages.login_background_tablet + ', ' +
        _vm.platformImages.login_background_tablet_2x + ' 2x',
      "media": "(min-width: 580px) and (min-height: 580px)"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": _vm.platformImages.login_background_mobile + ', ' +
        _vm.platformImages.login_background_mobile_2x + ' 2x',
      "media": "(max-width: 580px)"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.platformImages.login_background_tablet_wide,
      "srcset": _vm.platformImages.login_background_tablet_wide + ', ' +
        _vm.platformImages.login_background_tablet_wide_2x + ' 2x',
      "alt": _vm.$t('web.login.alt_text_background_image')
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41fe41a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 528
// module chunks = 1